<template>
  <div>
    <div style="position: absolute; z-index: 1000; margin: 10px; top:60px; left: 30px;">
      <div style="width: 350px; height: 66vh; overflow-y: auto; overflow-x: hidden; background: transparent;">
        <el-card class="box-card" @click.native.stop>
          <el-collapse v-model="activeNames" style="border: none;padding: 0 20px;" @click.native.stop>
            <el-collapse-item :title="'巡检轨迹：' + workList.length" name="1">
              <div 
                v-for="(item, index) in workList" 
                :key="item.WOId" 
                class="cardText" 
                @click.stop="showViewInfo(item)"
              >
                <div style="display: flex; align-items: center">
                  <div class="xuhao">{{ index + 1 }}</div>
                  <div style="width: 85%;">
                    <div class="title">
                      {{ item.inspectionName }}
                    </div>
                    <div class="time">
                      {{ item.userName }}
                    </div>
                    <div class="time">
                      {{ item.createTime }}
                    </div>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </div>
    </div>
    <div id="app1">
      <div id="allmap" ref="allmap" />
    </div>
    <el-dialog
      :title="siginInfo.userName + '的巡检记录'"
      width="600px"
      :visible.sync="siginViewVisb"
      :destroy-on-close="true"
      append-to-body
      :before-close="siginViewVisbClose"
      class="headerts siandaoinfoWork"
    >
      <div style="color: black;line-height: 30px;">
        <div>巡检点：{{ siginInfo.inspectionName }}</div>
        <div>
          状态：
          <el-tag type="success" size="mini" v-if="siginInfo.status == 1">正常</el-tag>
          <el-tag type="warning" size="mini" v-if="siginInfo.status == 2">异常</el-tag>
        </div>
        <div v-if="siginInfo.remark">描述：{{ siginInfo.remark }}</div>
        <div>巡检时间：{{ siginInfo.createTime }}</div>
      </div>
      <div class="demo-image__preview" v-if="siginInfo.img">
        <div v-for="(item, index) in siginInfo.img.split(',')" :key="index">
          <image-preview :src="item" :width="56" :height="56" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/config/index'
import { sysInspectionRecordList } from '@/api/clockIn'

// 天地图配置
const TIANDITU_CONFIG = {
  tk: 'e4d924258c1084ed7cde9c76fed4d520',
}

export default {
  props: {
    workInfo: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      map: null,
      pageResult: [],
      // 签到弹窗
      siginViewVisb: false,
      siginInfo: {},
      activeNames: ['1'],
      workList: [],
      markers: [],        // 存储标记点
      polylines: [],      // 存储轨迹线
      labels: [],         // 存储序号标签
      isMapInitialized: false,
    }
  },
  methods: {
    findPage() {
      let that = this
      if (!this.workInfo || !this.workInfo.userId) {
        console.warn('workInfo数据不完整', this.workInfo)
        return
      }
      
      this.workList = []
      sysInspectionRecordList({
        companyId: that.$route.query.EId,
        platformId: that.$route.query.platformId,
        userId: this.workInfo.userId,
        pageNum: 1,
        pageSize: 99,
        beginTime: this.workInfo.beginTime,
        endTime: this.workInfo.endTime,
      }).then((res) => {
        this.workList = res.data.list || []
        // 加载天地图API
        this.loadTiandituAPI()
      }).catch(error => {
        console.error('获取巡检记录失败', error)
      })
    },
    
    loadTiandituAPI() {
      // 先销毁旧地图
      this.destroyMap()
      
      if (window.T && window.T.Map) {
        this.initMap()
        return
      }

      if (document.querySelector('script[src*="api.tianditu.gov.cn"]')) {
        const checkInterval = setInterval(() => {
          if (window.T && window.T.Map) {
            clearInterval(checkInterval)
            this.initMap()
          }
        }, 100)
        return
      }

      const script = document.createElement('script')
      script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${TIANDITU_CONFIG.tk}`
      script.onload = () => {
        console.log('天地图API加载成功')
        setTimeout(() => {
          this.initMap()
        }, 500)
      }
      script.onerror = () => {
        console.error('天地图API加载失败')
        this.$message.error('地图API加载失败，请检查网络或密钥')
      }
      document.head.appendChild(script)
    },
    
    initMap() {
      const mapElement = document.getElementById('allmap')
      if (!mapElement) {
        console.error('地图容器不存在')
        return
      }
      
      mapElement.innerHTML = ''
      
      // 获取中心点坐标
      let centerPoint = { lat: 34.659665, lng: 112.42033 }
      if (this.workInfo && this.workInfo.userLocation && this.workInfo.userLocation !== '') {
        try {
          const location = JSON.parse(this.workInfo.userLocation)
          if (location && location.lat && location.lng) {
            centerPoint = { lat: location.lat, lng: location.lng }
          }
        } catch (e) {
          console.error('解析坐标失败', e)
        }
      }

      try {
        this.map = new T.Map('allmap')
        const point = new T.LngLat(centerPoint.lng, centerPoint.lat)
        this.map.centerAndZoom(point, 15)
        this.map.enableScrollWheelZoom(true)
        
        console.log('天地图初始化成功')
        this.isMapInitialized = true
        
        // 地图初始化完成后，绘制轨迹
        this.$nextTick(() => {
          this.drawTrack(this.workList)
        })
      } catch (e) {
        console.error('地图初始化失败', e)
      }
    },
    
    destroyMap() {
      this.clearOverlays()
      if (this.map) {
        try {
          // 清除地图上的所有覆盖物
          if (this.map.clearOverLays) {
            this.map.clearOverLays()
          }
          this.map = null
        } catch (e) {
          console.error('销毁地图失败', e)
        }
      }
      this.isMapInitialized = false
    },
    
    clearOverlays() {
      // 清除标记点 - 天地图中使用 removeOverLay
      if (this.markers.length > 0) {
        this.markers.forEach(marker => {
          if (marker && this.map) {
            try {
              this.map.removeOverLay(marker)
            } catch (e) {}
          }
        })
        this.markers = []
      }
      
      // 清除轨迹线
      if (this.polylines.length > 0) {
        this.polylines.forEach(polyline => {
          if (polyline && this.map) {
            try {
              this.map.removeOverLay(polyline)
            } catch (e) {}
          }
        })
        this.polylines = []
      }
      
      // 清除序号标签
      if (this.labels.length > 0) {
        this.labels.forEach(label => {
          if (label && this.map) {
            try {
              this.map.removeOverLay(label)
            } catch (e) {}
          }
        })
        this.labels = []
      }
    },
    
    drawTrack(trackData) {
      if (!this.map || !this.isMapInitialized) {
        console.error('地图未初始化')
        return
      }
      
      if (!trackData || trackData.length === 0) {
        console.log('没有轨迹数据')
        return
      }
      
      this.clearOverlays()
      
      const points = []
      const that = this
      
      // 遍历轨迹数据，创建标记点
      for (let i = 0; i < trackData.length; i++) {
        const signInfo = trackData[i]
        
        if (!signInfo.userLocation || signInfo.userLocation === '[]') {
          console.warn(`第${i + 1}个点没有坐标数据`)
          continue
        }
        
        try {
          const coordinate = JSON.parse(signInfo.userLocation)
          
          if (!coordinate || typeof coordinate.lat === 'undefined' || typeof coordinate.lng === 'undefined') {
            console.error('坐标格式错误', coordinate)
            continue
          }
          
          const point = new T.LngLat(coordinate.lng, coordinate.lat)
          points.push(point)
          
          // 创建标记点
          this.addMarker(point, signInfo, i)
          
          // 添加序号标签
          this.addLabelWithMarker(point, i + 1)
          
        } catch (e) {
          console.error('解析坐标失败', e)
        }
      }
      
      // 绘制轨迹线
      if (points.length > 1) {
        this.drawPolyline(points)
      }
      
      // 调整地图视野以显示所有点
      if (points.length > 0) {
        this.fitBounds(points)
      }
    },
    
    addMarker(point, signInfo, index) {
      try {
        // 创建标记点
        const marker = new T.Marker(point)
        
        // 存储标记点信息
        marker.signInfo = signInfo
        marker.index = index
        
        // 添加点击事件
        marker.addEventListener('click', () => {
          this.showViewInfo(signInfo)
        })
        
        // 天地图中使用 addOverLay 添加覆盖物
        this.map.addOverLay(marker)
        this.markers.push(marker)
        
        console.log(`添加标记点${index + 1}成功`, point)
      } catch (e) {
        console.error('添加标记点失败', e)
      }
    },
    
    // 使用自定义图标的方式添加序号标签
    addLabelWithMarker(point, index) {
      try {
        // 创建一个带数字的图标
        const canvas = document.createElement('canvas')
        canvas.width = 30
        canvas.height = 30
        const ctx = canvas.getContext('2d')
        
        // 绘制圆形背景
        ctx.beginPath()
        ctx.arc(15, 15, 12, 0, 2 * Math.PI)
        ctx.fillStyle = '#ff0000'
        ctx.fill()
        ctx.strokeStyle = '#ffffff'
        ctx.lineWidth = 2
        ctx.stroke()
        
        // 绘制数字
        ctx.fillStyle = '#ffffff'
        ctx.font = 'bold 14px Arial'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText(index.toString(), 15, 15)
        
        // 创建图标
        const icon = new T.Icon({
          iconUrl: canvas.toDataURL(),
          iconSize: new T.Point(30, 30),
          iconAnchor: new T.Point(15, 15)
        })
        
        // 创建带序号的标记点
        const labelMarker = new T.Marker(point, { icon: icon })
        
        // 添加点击事件
        labelMarker.addEventListener('click', () => {
          const signInfo = this.workList[index - 1]
          if (signInfo) {
            this.showViewInfo(signInfo)
          }
        })
        
        // 添加到地图
        this.map.addOverLay(labelMarker)
        this.labels.push(labelMarker)
        
        console.log(`添加序号标签${index}成功`)
      } catch (e) {
        console.error('添加序号标签失败', e)
        // 如果上述方法失败，使用备用方案：简单的文本标签
        this.addSimpleTextLabel(point, index)
      }
    },
    
    // 备用方案：使用文本标签
    addSimpleTextLabel(point, index) {
      try {
        // 创建div容器
        const div = document.createElement('div')
        div.style.backgroundColor = '#ff0000'
        div.style.color = '#ffffff'
        div.style.fontSize = '14px'
        div.style.fontWeight = 'bold'
        div.style.width = '24px'
        div.style.height = '24px'
        div.style.borderRadius = '50%'
        div.style.display = 'flex'
        div.style.alignItems = 'center'
        div.style.justifyContent = 'center'
        div.style.border = '2px solid #ffffff'
        div.style.boxShadow = '0 2px 4px rgba(0,0,0,0.3)'
        div.style.fontFamily = 'Arial, sans-serif'
        div.style.cursor = 'pointer'
        div.textContent = index.toString()
        
        // 添加点击事件
        div.onclick = () => {
          const signInfo = this.workList[index - 1]
          if (signInfo) {
            this.showViewInfo(signInfo)
          }
        }
        
        // 创建标注
        const label = new T.Label(div, point, {
          offset: new T.Point(-12, -12)
        })
        
        // 添加到地图
        this.map.addOverLay(label)
        this.labels.push(label)
        
        console.log(`添加文本标签${index}成功`)
      } catch (e) {
        console.error('添加文本标签失败', e)
      }
    },
    
    drawPolyline(points) {
      try {
        // 创建轨迹线
        const polyline = new T.Polyline(points, {
          color: '#ff0000',
          weight: 4,
          opacity: 0.8,
          lineStyle: 'solid'
        })
        
        // 天地图中使用 addOverLay 添加覆盖物
        this.map.addOverLay(polyline)
        this.polylines.push(polyline)
        
        console.log('轨迹线绘制成功，点数：', points.length)
      } catch (e) {
        console.error('绘制轨迹线失败', e)
      }
    },
    
    fitBounds(points) {
      try {
        if (points.length === 0) return
        
        // 如果只有一个点，直接定位到该点
        if (points.length === 1) {
          this.map.centerAndZoom(points[0], 15)
          return
        }
        
        // 计算边界
        let minLng = points[0].getLng()
        let maxLng = points[0].getLng()
        let minLat = points[0].getLat()
        let maxLat = points[0].getLat()
        
        points.forEach(point => {
          const lng = point.getLng()
          const lat = point.getLat()
          minLng = Math.min(minLng, lng)
          maxLng = Math.max(maxLng, lng)
          minLat = Math.min(minLat, lat)
          maxLat = Math.max(maxLat, lat)
        })
        
        // 添加一些边距
        const lngMargin = (maxLng - minLng) * 0.2
        const latMargin = (maxLat - minLat) * 0.2
        
        // 计算中心点
        const centerLng = (minLng + maxLng) / 2
        const centerLat = (minLat + maxLat) / 2
        const centerPoint = new T.LngLat(centerLng, centerLat)
        
        // 计算合适的缩放级别
        // 根据经纬度范围计算缩放级别
        const lngDiff = maxLng - minLng + lngMargin * 2
        const latDiff = maxLat - minLat + latMargin * 2
        const maxDiff = Math.max(lngDiff, latDiff)
        
        let zoom = 15
        if (maxDiff > 0.5) {
          zoom = 10
        } else if (maxDiff > 0.2) {
          zoom = 12
        } else if (maxDiff > 0.05) {
          zoom = 14
        } else if (maxDiff > 0.01) {
          zoom = 16
        } else {
          zoom = 18
        }
        
        // 设置地图中心和缩放级别
        this.map.centerAndZoom(centerPoint, zoom)
        
        console.log('调整地图视野成功，中心点：', centerPoint, '缩放级别：', zoom)
      } catch (e) {
        console.error('调整地图视野失败', e)
        // 如果计算失败，至少定位到第一个点
        if (points.length > 0) {
          this.map.centerAndZoom(points[0], 13)
        }
      }
    },
    
    siginViewVisbClose() {
      this.siginViewVisb = false
    },
    
    showViewInfo(signInfo) {
      console.log('showViewInfo点击了', signInfo)
      this.siginViewVisb = true
      this.siginInfo = signInfo
    },
  },
  beforeDestroy() {
    this.destroyMap()
  },
  watch: {
    workInfo: {
      handler(newVal, oldVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.$nextTick(() => {
            this.findPage()
          })
        }
      },
      deep: true,
      immediate: false
    }
  },
  mounted() {
    if (this.workInfo && Object.keys(this.workInfo).length > 0) {
      this.findPage()
    }
  }
}
</script>

<style scoped lang="scss">
#allmap {
  width: 100%;
  height: 68.2vh;
}
.el-image-viewer__wrapper {
  z-index: 2012;
}
/*滚动条的宽度*/
::-webkit-scrollbar {
  width: 4px;
  height: 8px;
}
::-webkit-scrollbar-track {
  width: 6px;
  background-color: #ebedee;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
::-webkit-scrollbar-thumb {
  background-color: #bdc3c5;
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgb(160, 158, 158);
}

/* 卡片样式 */
.box-card {
  position: relative;
  z-index: 1001;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.box-card /deep/ .el-card__body {
  padding: 0 !important;
}

/* 折叠面板样式 */
.el-collapse {
  border-top: none;
  border-bottom: none;
}

.el-collapse-item__header {
  height: 40px;
  line-height: 40px;
  background-color: #f5f7fa;
  padding-left: 10px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
}

.el-collapse-item__header.is-active {
  border-bottom-color: #ebeef5;
}

.el-collapse-item__wrap {
  border-bottom: none;
  background-color: #ffffff;
}

.el-collapse-item__content {
  padding: 15px 10px;
  max-height: calc(66vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
  line-height: 1.3;
}

/* 列表项样式 */
.cardText {
  margin-bottom: 10px;
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid #e3e6eb;
  transition: all 0.3s;
  background-color: #ffffff;
}

.cardText:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

.cardText:hover {
  background: #1890ff;
  color: white;
  border-radius: 5px;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  
  .time {
    color: white;
  }
}

.title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}

.time {
  color: #666666;
  font-size: 12px;
  line-height: 1.5;
}

.xuhao {
  background-image: url(https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/9d71.png);
  width: 24px;
  height: 32px;
  margin-left: -10px;
  margin-top: -10px;
  margin-right: 8px;
  text-align: center;
  line-height: 32px;
  color: white;
  font-weight: bold;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
}

.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 95px;
}

.demo-image__preview {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.demo-image__preview div {
  margin-right: 0;
  margin-top: 0;
}

/* 确保点击事件正常 */
#app1 {
  position: relative;
  z-index: 1;
}
</style>